var getInitial = function (value) {
    var _a;
    return value ? (_a = Array.from(value)[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase() : '';
};
export var getInitials = function (firstName, lastName) {
    var firstInitial = getInitial(firstName);
    var lastInitial = getInitial(lastName);
    return "".concat(firstInitial).concat(lastInitial);
};
